
import Reflux from 'reflux';

export default Reflux.createActions([
  'loadTags',
  'loadTagsError',
  'loadTagsSuccess'
]);



/** WEBPACK FOOTER **
 ** ./app/actions/streamTagActions.jsx
 **/